import { HisSearchCriteriaSetStateType } from './his-search-criteria-set-state-type';
import { HisSearchCriteriaSet } from './his-search-criteria-set';

export class HisSearchCriteriaSetStateInfo {

    stateType: HisSearchCriteriaSetStateType;
    currentCriteriaSet: HisSearchCriteriaSet;

}
